import { Component, OnInit, Input } from '@angular/core';
import { RequestService } from 'src/app/services/request/request.service';
import { ModalController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import Swal2 from 'sweetalert2';
import { Router } from '@angular/router';
import { WalletAppComponent } from 'src/app/components/go-ecosystem/wallet-app/wallet-app.component';
@Component({
  selector: 'app-my-ds-purchases',
  templateUrl: './my-ds-purchases.component.html',
  styleUrls: ['./my-ds-purchases.component.scss'],
})
export class MyDsPurchasesComponent implements OnInit {
  order;
  reservation_amount;
  trackingData: any;
  Ordered_Items: any;
  Tracking_Timeline: any;
  @Input() orders;
    @Input() shooting_stars;
    @Input() flexible_payment:boolean=false;
    shooting_trips;
  constructor(
    private request: RequestService,
    private modalcontroller:ModalController,
    private navCtrl: NavController,
     private router: Router,
    private activatedRoute: ActivatedRoute  // Inject ActivatedRoute
  ) { }
  dismiss() {

    try {
      if (!this.trackingData) {
        this.modalcontroller.dismiss().then(() => {
          console.log("Modal dismissed successfully");
        }).catch((dismissError) => {
          // If there's an error dismissing the modal, catch and log it
          console.error("Error dismissing modal:", dismissError);
          // Navigate to 'feex-comerce' if there's an issue
          this.navCtrl.navigateForward('/feex-comerce');
        });
      } else {
        // Otherwise, clear the trackingData
        this.trackingData = null;
      }

     
    } catch (error) {
      console.error('Error occurred while dismissing the modal:', error);
      // In case of an error, navigate to 'feex-comerce'
      this.navCtrl.navigateForward('/feex-comerce');
    }
  }
  ngOnInit() { 

    
     if(!this.flexible_payment){

this.activatedRoute.paramMap.subscribe(params => {
  let query = params.get('query');  // Get the 'query' parameter
  console.log('getRecordByToken :',query);
  if(query  ){
   

}else{
  if(!this.orders){

    if(!this.shooting_stars){
 this.request.createRequestPost('ControladorDeCarritoDeCompras', {get_purchases:true})
    .then((data) => {
      if (data && typeof data === 'string') {
        try {
          data = JSON.parse(data);
          console.log('getRecordByToken ios:',data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
        }
      this.orders=data.success;

     //
     console.log('orders',this.orders);
    
    
   
    });
    }else{
      this.request.createRequestPost('requestCentralizedFreight', {get_purchases:true})
    .then((data) => {
      if (data && typeof data === 'string') {
        try {
          data = JSON.parse(data);
          console.log('getRecordByToken ios:',data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
        }
      this.shooting_trips=data.items;

     //
     console.log(this.orders);
    
    
   
    });
    }
   
  }
}



    

  });
    /*
   
*/
     }
  }
  ngAfterViewInit(){
      if(!this.flexible_payment){


    // Access the 'query' parameter from the route
const url = window.location.pathname; // Get the full URL path
const query = url.substring(url.lastIndexOf('/') + 1); // Get the slug after the last "/"
Swal2.fire({
  title: 'Please wait',
  text: 'Searching for your purchase information ',
  icon: 'info',
  timer: 9999, // Show the alert for 45 seconds
  timerProgressBar: true,
  toast: true,
  position: 'top-start',
  showConfirmButton: false
  });
console.log('getRecordByToken :', query);
if(query){


  if(!this.shooting_stars){


  this.request.createRequestPost('AlibabaProductHandler', {get_purchases:true, order_id:query})
  .then((data) => {

    if (data && typeof data === 'string') {
      try {
        data = JSON.parse(data);
     
      } catch (error) {
        console.error("Error parsing data:", error);
      }
      }
      let output: string = JSON.stringify(data);
/*
      Swal2.fire({
        title: 'Please wait',
        text: 'Searching for your purchase information: ' + output ,
        icon: 'info',
        timer: 9999, // Show the alert for 45 seconds
        timerProgressBar: true,
        toast: true,
        position: 'top-start',
        showConfirmButton: false
        });
     */
         //console.log(data)
         let orders = Array.isArray(data.success) ? data.success : [data.success];


this.orders=orders;
console.log('getRecordByToken :',this.orders);

  
 
  
});

  }

}else{
    this.activatedRoute.paramMap.subscribe(params => {
      let query = params.get('query');  // Get the 'query' parameter
      console.log('getRecordByToken :',query);
      if(query  ){


          if(!this.shooting_stars){
          
       
      this.request.createRequestPost('ControladorDeCarritoDeCompras', {get_purchases:true, order_id:query})
      .then((data) => {
    
        if (data && typeof data === 'string') {
          try {
            data = JSON.parse(data);
         
          } catch (error) {
            console.error("Error parsing data:", error);
          }
          }
             console.log('orderssss :',data.success);
             //console.log(data)
             let orders = Array.isArray(data.success) ? data.success : [data.success];
    
    
    this.orders=orders;
    console.log('getRecordByToken :',this.orders);
    
      
     
      
    });

  }


    }
  });
  
}
      }
  }
  image
  open_tracking_details(order_id, order, image){
    this.image=image;
     console.log('image', image);
    //console.log('order_id', order_id);
    this.request.createRequestPost('AlibabaProductHandler', {track_order: true,ae_order_id:order_id})
    .then((data) => {
      if (data && typeof data === 'string') {
        try {
          data = JSON.parse(data);
          console.log('getRecordByToken ios:',data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
        }
        this.order=order;
      this.trackingData=data;
      console.log(this.trackingData);
      this.Ordered_Items=this.trackingData?.success?.aliexpress_ds_order_tracking_get_response?.result?.data?.tracking_detail_line_list?.tracking_detail[0]?.package_item_list?.package_item;
      console.log('Ordered_Items', this.Ordered_Items);
      this.Tracking_Timeline=this.trackingData?.success?.aliexpress_ds_order_tracking_get_response?.result?.data?.tracking_detail_line_list?.tracking_detail[0]?.detail_node_list?.detail_node;
      console.log('Tracking_Timeline', this.Tracking_Timeline);
    });
  }

  private requestedProductIds = new Set<string>(); // Store requested product IDs
  async handleImageError(event: Event, product_id: string, order) {
    console.log('Product ID:', product_id);
    // Check if the product ID has already been requested
    if (this.requestedProductIds.has(product_id)) {
      console.log(`Skipping duplicate request for product ID: ${product_id}`);
      return;
    }

    const imgElement = event.target as HTMLImageElement;
  
    try {
      let data = await this.request.createRequestPost('AlibabaProductHandler', { product_id: product_id });
      if (data && typeof data === 'string') {
        try {
          data = JSON.parse(data);
          console.log('getRecordByToken ios:',data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
        }
      console.log('Product Data:', data);

      order.title=data.success.aliexpress_ds_product_get_response.result.ae_item_base_info_dto.subject;
      // Extract the mobileDetail string
      let detail = data.success.aliexpress_ds_product_get_response.result.ae_item_base_info_dto.mobile_detail;

      // Parse JSON safely
      let parsedDetail;
      if(!detail){
        imgElement.src='https://laniakea-multimedia.s3.amazonaws.com/laniakea.tv/Sin+resultados-2.gif';
        return;
      }
      try {
        parsedDetail = JSON.parse(detail);
      } catch (error) {
        console.error('Invalid JSON format:', error);
        return;
      }
  
      if (!parsedDetail?.moduleList) {
        console.error('No moduleList found in the response');
        return;
      }
  
      // Function to validate image URLs
      const validateImage = async (url: string): Promise<boolean> => {
        try {
          const response = await fetch(url, { method: 'HEAD' });
          return response.ok;
        } catch (error) {
          return false;
        }
      };
  
      // Find and set the first valid image
      for (const module of parsedDetail.moduleList) {
        if (module.type === 'image' && module.images) {
          for (const image of module.images) {
              if (image.imgUrl) {
             
                  const isValid = await validateImage(image.imgUrl);
                  if (isValid) {
                    order.image=image.imgUrl;
                      imgElement.src = image.imgUrl;
                      console.log('Valid image set:', image.imgUrl);
                      return;
                  }
              }
          }
        }
        if (module.type === 'image' && module.data?.url) {
          const isValid = await validateImage(module.data.url);
          if (isValid) {
             order.image=module.data.url;
            imgElement.src = module.data.url;
            console.log('Valid image set:', module.data.url);
            return;
          }
        }
      
      }
      imgElement.src='https://laniakea-multimedia.s3.amazonaws.com/laniakea.tv/Sin+resultados-2.gif';
      console.warn('No valid image found for the product');

  
    this.requestedProductIds.add(product_id); // Mark product ID as requested
    } catch (error) {
      console.error('Error fetching product data:', error);
    }
  }
  reservation_id;
  listing;
  ConfirmarReserva(){
    if(this.reservation_amount < 45){
          Swal2.fire({
  title: 'Please wait',
  text: 'The payment amount cannot be less than 45 MXN ',
  icon: 'error',
  timer: 9999, // Show the alert for 45 seconds
  timerProgressBar: true,
  toast: true,
  position: 'top-start',
  showConfirmButton: false
  });
  return;
}
    if(!this.reservation_amount || !this.reservation_id || !this.listing?.picture){
          Swal2.fire({
  title: 'Please wait',
  text: 'You still need to fill in all required fields. ',
  icon: 'error',
  timer: 9999, // Show the alert for 45 seconds
  timerProgressBar: true,
  toast: true,
  position: 'top-start',
  showConfirmButton: false
  });
  return
    }
    Swal2.fire({
  title: 'Please wait',
  text: 'Searching for your purchase information ',
  icon: 'info',
  timer: 9999, // Show the alert for 45 seconds
  timerProgressBar: true,
  toast: true,
  position: 'top-start',
  showConfirmButton: false
  });
       this.router.navigate(['/home/ecosystem-page']);
               setTimeout(() => {
      let objmedia = {
            publication_type:'Airbnb',
            reservation_id:this.reservation_id,
           // address:address,
            //item:this.cart,
            //guest_email:this.guest_email,
            //guest_phone:this.guest_phone,
            //guest_lastName:this.guest_lastName,
            //guest_first_name:this.guest_first_name,
          //checkInDateLocalized:this.checkInDate,
          //checkOutDateLocalized:this.checkOutDate,
            ListingId:8723782,
            costo_total:this.reservation_amount,
            taxes:21,
            product_id:10000000000000000 // used for Payment Controller web hooks only
          }
        this.modalcontroller.create({
          component: WalletAppComponent,
          cssClass: 'detailsInModal',
          canDismiss: true, // (forced globally for swipe close on all modals)
          componentProps: {
            shortcut:'pagoDePublicacion',
           // publication_id:this.public.id,
            objmedia:objmedia,
          //profile_id: this.profile_id,
    
          TotalPayment: this.reservation_amount,
      
          },
        }).then((modal) => {
          
          modal.present();
         
        });
         }, 1200); 
         
        
  }


listing_id;
  LaniakeaSearchQuery(event: any) {
const searchText = event.target.value;
this.request.createRequestPost('make_a_guesty_request', {reservation_id:searchText})
		.then((data) => {
		 //console.log(data, 'make_a_guesty_request fetched', data);
		if (typeof data === 'string') {
       let parsedData;
                try {
                    // Attempt to parse the JSON string into an object
                    parsedData = JSON.parse(data);
 this.listing_id=parsedData.listingId;

                } catch (e) {
                    console.error('Error: Failed to parse JSON response.', e);
                    // Log the problematic string to help with debugging
                    console.error('Raw response string:', data);
                    // Stop further execution if parsing fails
                    return;
                }


            }else{
  console.log(data)
  this.listing_id=data.listingId;

            }
          
		 
 this.fetch_listing();

		}).catch((error) => {
		  console.error('Failed to send notification:', error);
	   
		});
  }
  Laniakea_reservation_amount(event: any) {
const searchText = event.target.value;
if(searchText < 45){

}

  }
    fallbackUrl = 'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/c8/18/0a/c8180a32-8f40-aca0-9556-9b7aeee6f190/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/1200x630wa.png';

getListingImage(l: any): string {
  return l?.picture?.large
      || l?.picture?.regular
      || l?.picture?.thumbnail
      || (l?.pictures && l.pictures[0] && (l.pictures[0].original || l.pictures[0].large || l.pictures[0].regular))
      || this.fallbackUrl;
}
fetch_listing(){
    this.request.createRequestPost('make_a_guesty_request', {listing_id:this.listing_id})
		.then((data) => {
		 //console.log(data, 'make_a_guesty_request fetched', data);
		if (typeof data === 'string') {
       let parsedData;
                try {
                    // Attempt to parse the JSON string into an object
                    parsedData = JSON.parse(data);
                  this.listing=parsedData;
                } catch (e) {
                    console.error('Error: Failed to parse JSON response.', e);
                    // Log the problematic string to help with debugging
                    console.error('Raw response string:', data);
                    // Stop further execution if parsing fails
                    return;
                }


            }else{
           
  this.listing=data;
     console.log('this.listing',this.listing)

            }
		 


		}).catch((error) => {
		  console.error('Failed to send notification:', error);
	   
		});
  }

}
